/**
 * Radio search grid — filter→param builder.
 *
 * Turns the Search view's radio filter bar (online status, customer/group
 * scope, placement, and the staff-only active/deleted toggle) into the
 * EntityGrid `extraParams` object for odl-app/radios/. Kept feature-local
 * so the endpoint's `filter[...]` names live next to the grid, while the
 * scope contract composes from the shared queryParams kit.
 *
 * Contains:
 * - buildRadioGridParams — filter state → extraParams
 */

import { buildQueryParams, withScope } from '@sophocles/utils/queryParams';

/** Backend filter[<field>] param names owned by the radios endpoint. */
const FILTER_ONLINE = 'online';
const FILTER_PLACEMENT = 'placement';
const FILTER_DELETED = 'deleted';

/**
 * @param {Object} filters
 * @param {string} [filters.onlineFilter] - '', 'true', or 'false'
 * @param {number|string} [filters.customerFilter]
 * @param {number|string} [filters.siteGroupFilter]
 * @param {string} [filters.placementFilter]
 * @param {'active'|'deleted'|'all'} [filters.deletedFilter]
 * @param {boolean} [filters.isStaff]
 * @returns {Object} EntityGrid extraParams
 */
export const buildRadioGridParams = ({
  onlineFilter,
  customerFilter,
  siteGroupFilter,
  placementFilter,
  deletedFilter,
  isStaff,
}) =>
  buildQueryParams(
    onlineFilter !== '' ? { [FILTER_ONLINE]: onlineFilter } : {},
    withScope({}, { customerId: customerFilter, siteGroupId: siteGroupFilter }),
    placementFilter ? { [FILTER_PLACEMENT]: placementFilter } : {},
    isStaff && deletedFilter === 'active' ? { [FILTER_DELETED]: 'false' } : {},
    isStaff && deletedFilter === 'deleted' ? { [FILTER_DELETED]: 'true' } : {},
  );
